import { Rule } from './rule';

export class SolitaireCheatSheet {
  public static readonly allCheatSheets: Rule[] = [
    {
      title: 'components.cheat-sheet.solitaire.header-1',
      body: [
        {
          type: 'text',
          content: 'components.cheat-sheet.solitaire.body-1',
        },
      ],
    },
    {
      title: 'components.cheat-sheet.solitaire.header-2',
      body: [
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-2a' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-2b' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-2c' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-2d' },
      ],
    },
    {
      title: 'components.cheat-sheet.solitaire.header-3',
      body: [
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-3a' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-3b' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-3c' },
      ],
    },
    {
      title: 'components.cheat-sheet.solitaire.header-4',
      body: [
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-4a' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-4b' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-4c' },
        { type: 'text', content: 'components.cheat-sheet.solitaire.body-4d' },
      ],
    },
  ];
}
